import "./index.scss";

export const Tooltip = ({
  position = "top",
  customClassName = "",
  content,
  children,
  borderColor = "white"
}) => {
  return (
    <div className={`tooltip ${customClassName}`}>
      {children}
      <span style={{ borderColor }} className={`tooltip-content ${position}`}>
        <div className="tooltip-bubble">{content}</div>
      </span>
    </div>
  );
};
